import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
            实时动态
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {updatesData.title}
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updatesData.items.map((item, idx) => {
              const tagColors: Record<string, string> = {
                '最新': 'bg-primary-500 text-background-50',
                '热度': 'bg-accent-500 text-background-50',
                '更新': 'bg-secondary-500 text-background-50',
                '爆料': 'bg-primary-600 text-background-50',
                '热点': 'bg-accent-600 text-background-50',
                '独家': 'bg-primary-700 text-background-50',
                '上线': 'bg-secondary-600 text-background-50',
              };
              const tagColor = tagColors[item.tag] || 'bg-background-400 text-background-50';

              return (
                <div key={idx} className="flex gap-4">
                  <div className="flex-shrink-0 relative z-10 mt-1">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                  </div>
                  <div className="flex-1 min-w-0 pb-2">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                      <span className={`px-1.5 py-0.5 text-xs font-medium rounded whitespace-nowrap ${tagColor}`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-800 leading-relaxed">
                      {item.content}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}